// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2t1JA","location":"Header_location__1QZUd"};